// extracted by mini-css-extract-plugin
module.exports = {"Row":"OrderDetails_Row__sV398","Space":"OrderDetails_Space__2LodE","BundlesOuter":"OrderDetails_BundlesOuter__1piA2"};